module.exports = __webpack_public_path__ + "static/media/international.355aca74.csv";